module.exports = require("./nb-NO.js");